import { CHECKOUT_URL, STORE_URL, TRACKING_PARAMS } from "../data/storeConfig";

export function withTrackingParams(baseUrl: string): string {
  if (typeof window === "undefined") return baseUrl;
  try {
    const incoming = new URLSearchParams(window.location.search);
    const url = new URL(baseUrl);
    let changed = false;
    TRACKING_PARAMS.forEach((key) => {
      const value = incoming.get(key);
      if (value) {
        url.searchParams.set(key, value);
        changed = true;
      }
    });
    return changed ? url.toString() : baseUrl;
  } catch {
    return baseUrl;
  }
}

export function getCheckoutUrl(): string {
  return withTrackingParams(CHECKOUT_URL);
}

export function getStoreUrl(): string {
  return withTrackingParams(STORE_URL);
}
